export const TOKEN_SCOPES = {
  USER_SCOPES: [
    "coupon:read",
    "coupon:write",
    "customer:read",
    "customer:write",
    "invoice:read",
    "invoice:write",
    "pay:read",
    "pay:write",
    "product:read",
    "product:write",
    "report:read",
    "upload:write",
    "bnpl:merchantread",
    "bnpl:merchantwrite",
    "refund:creation",
    "refund:recharge",
  ],
  ADMIN_SCOPES: [
    "affiliate:read",
    "affiliate:write",
    "client:register",
    "direct:read",
    "direct:write",
    "pay:refund",
    "withdraw:refund",
  ],
  IDENTITY_SCOPES: ["birthday", "email", "nationalcode", "phone", "profile", "shaba"],
} as const;

export enum CustomerTypeEnum {
  All = 0,
  Corporate = 1,
  Individual = 2,
}
